//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import {
  getEventImages,
  getImagesForOneSize,
} from '@/utils/event/getEventImages';
import LazyImg from '@/components/autoscale/lazyImg.vue';

export default {
  components: {
    LazyImg,
  },
  data() {
    return {
      images: null,
    };
  },
  computed: {
    event() {
      return this.$store.state.event.data;
    },
    topicStatus() {
      return this.$store.getters['event/topicStatus'];
    },
  },
  created() {
    this.getBackground();
  },
  methods: {
    getBackground() {
      const images = getEventImages(this.event);

      const eventImages = {
        desktop: { ...getImagesForOneSize(images, 'detailed', 'large') },
        tablet: { ...getImagesForOneSize(images, 'detailed', 'medium') },
        mobile: { ...getImagesForOneSize(images, 'detailed', 'small') },
      };

      this.images = eventImages;
    },
  },
};
